import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: 400;
  border-radius: ${({ borderRadius }) => borderRadius};
  border: 1px solid #e6e6e6;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background-color: ${({
    backgroundColor,
    active,
    activeBackgroundColor,
    theme,
  }) =>
    active
      ? activeBackgroundColor
        ? activeBackgroundColor
        : theme.primary
      : backgroundColor};
  font-size: ${({ lableFontSize }) => lableFontSize};
  color: ${({ theme, active }) => (active ? theme.white : theme.dark40)};
  cursor: pointer;
  transition: all 0.3s ease, transform 0.2s ease;
  box-shadow: ${({ active }) =>
    active
      ? '0px 1px 4px rgba(0, 0, 0, 0.06) inset'
      : '0px 1px 4px rgba(0, 0, 0, 0.06) inset'};
  &:active {
    transform: translateY(1px);
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
  }
`;

const StyledToogleButton = ({
  width = '95px',
  height = '30px',
  active = false,
  enableText = 'Enable',
  disableText = 'Disable',
  lableFontSize = '14px',
  borderRadius = '5px',
  backgroundColor = '#fff',
  activeBackgroundColor,
  onChange = () => {},
}) => {
  const handleClick = () => {
    onChange(!active); // Toggle active state on click
  };

  return (
    <StyledContainer
      active={active}
      borderRadius={borderRadius}
      lableFontSize={lableFontSize}
      activeBackgroundColor={activeBackgroundColor}
      height={height}
      width={width}
      backgroundColor={backgroundColor}
      onClick={handleClick} // Trigger onChange when clicked
    >
      {active ? enableText : disableText}
    </StyledContainer>
  );
};

export default StyledToogleButton;
